export async function resolveActiveMemberships<T extends { isActive?: boolean }>(
  companyIds: unknown[],
  lookup: (companyId: string) => Promise<T | null>
): Promise<T[]> {
  const ids = [...new Set(companyIds.filter(
    (id): id is string => typeof id === 'string' && id.length > 0 && !id.includes('/')
  ))];
  const results = await Promise.allSettled(ids.map(lookup));
  const memberships: T[] = [];
  const failures: unknown[] = [];
  for (const result of results) {
    if (result.status === 'rejected') failures.push(result.reason);
    else if (result.value?.isActive === true) memberships.push(result.value);
  }
  // A denied or failed verification is not proof that the account has no membership.
  if (memberships.length === 0 && failures.length > 0) throw failures[0];
  return memberships;
}
